<template>
  <accordion ref="accordion" v-model="mostrarAccordion">
    <div slot="header">10. Motivo Exclusão/Substituição/Redimensionamento</div>
    <div v-if="!loading">
      <unicom-linha
        class="espacamento-vertical"
        v-for="(value, key) in safeRowsComputed"
        :key="key"
      >
        <unicom-coluna sm="12" md="6">
          <div class="medio segunda-cor-fonte">{{ nomeCampos[key] }}:</div>
        </unicom-coluna>
        <unicom-coluna sm="12" md="6">
          <div class="medio">
            {{ value || " - " }}
          </div>
        </unicom-coluna>
      </unicom-linha>
      <unicom-paginacao-v3
        v-if="qtTotal > 0"
        :mostrarBotaoUltimo="false"
        textoExibindo="resultados"
        :qtPaginaAtual="qtPaginaAtual"
        :qtTotal="this.zeroEsquerda(qtTotal, 2)"
        :qtPaginas="qtPaginas"
        v-model="pagina"
      />
    </div>
    <unicom-spinner
      v-else
      style="min-height: 76px"
      :tamanhoLoading="62"
      :tamanhoLinha="7"
      :velocidade="0.5"
      :marginTopTexto="30"
      mensagem="Carregando..."
    />
  </accordion>
</template>

<script>
import DadosGeraisMixin from "../DadosGeraisMixin";
import TabelaFrontMixin from "@/shared/mixin/TabelaFrontMixin";

export default {
  name: "MotivoExclusao",
  mixins: [DadosGeraisMixin, TabelaFrontMixin],
  data() {
    return {
      pagina: 1,
      quantidadePagina: 1,
      objetoInformacoes: [],
      nomeCampos: {
        nivelExclusao: "Nível da exclusão",
        dtTermino: "Data de término",
        substituicao: "Substituição",
        cnpjCpfSubstituto: "CNPJ/CPF da Substituição",
        dtInicioPrest: "Data de início",
        codigoMotivoExclusao: "Código do motivo da exclusão",
        motivoExclusao: "Motivo da exclusão",
        codigoMotivoSubstituicao: "Código do motivo da substituição",
        motivoSubstituicao: "Motivo da substituição",
        nrOficio: "Número do ofício",
        exclusaoServico: "Exclusão Serviço",
        planoProduto: "Plano/Produto"
      }
    };
  },
  computed: {
    safeRowsComputed() {
      let teste =
        Array.isArray(this.rowsComputed) && this.rowsComputed.length > 0
          ? this.rowsComputed[0]
          : [];
      return teste;
    }
  },
  methods: {
    paginate(items, page, perPage) {
      const start = (page - 1) * perPage;
      const end = start + perPage;
      return items.slice(start, end);
    },
    calculateTotalPages(totalItems, perPage) {
      return Math.ceil(totalItems / perPage);
    },
    init() {
      if (this.iniciado) return;

      this.loading = true;
      this.sleep(150).then(() => {
        this.getMotivoExclusao(this.idRnpPrestador)
          .then(({ data }) => {
            if (Array.isArray(data) && data.length > 0) {
              this.objetoInformacoes = data.map(item => {
                const {
                  nivelExclusao: { descricao: descricaoNivelExclusao } = {
                    descricao: " - "
                  },
                  dtTermino,
                  substituicao: { descricao: descricaoSubstituicao } = {
                    descricao: " - "
                  },
                  cnpjCpfSubstituto,
                  dtInicioPrest,
                  motivoExclusao: {
                    chave: chaveMotivoExclusao,
                    descricao: descricaoMotivoExclusao
                  } = {
                    chave: " - ",
                    descricao: " - "
                  },
                  motivoSubstituicao: {
                    chave: chaveMotivoSubstituicao,
                    descricao: descricaoMotivoSubstituicao
                  } = { chave: " - ", descricao: " - " },
                  nrOficio,
                  exclusaoServico,
                  planoProduto
                } = item;
                return {
                  nivelExclusao: descricaoNivelExclusao,
                  dtTermino: dtTermino
                    ? this.$helpers.formatadorDataSafe(dtTermino)
                    : null,
                  substituicao: descricaoSubstituicao,
                  cnpjCpfSubstituto,
                  dtInicioPrest: dtInicioPrest
                    ? this.$helpers.formatadorDataSafe(dtInicioPrest)
                    : null,
                  codigoMotivoExclusao: chaveMotivoExclusao,
                  motivoExclusao: descricaoMotivoExclusao,
                  codigoMotivoSubstituicao: chaveMotivoSubstituicao,
                  motivoSubstituicao: descricaoMotivoSubstituicao,
                  nrOficio,
                  exclusaoServico,
                  planoProduto
                };
              });
              this.rows = this.objetoInformacoes;
            } else {
              this.objetoInformacoes = [];
              this.rows = this.objetoInformacoes;
            }
            this.iniciado = true;
          })
          .catch(() => {
            this.mostrarAccordion = false;
          })
          .finally(() => {
            this.loading = false;
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.espacamento-vertical {
  padding-bottom: 32px;

  &:last-child {
    padding-bottom: 0px;
  }
}
</style>
